import { transportationKeys } from '../../../../../consts/conditions';

export const checkHasAiActions = transform => {
  if (transform?.name === transportationKeys.REPLACE) {
    return transform?.items?.some(action => action?.thenInputType === 'ai_input');
  }

  return false;
};
